<template>
  <div
    class="plan-card-20676"
    :class="{ 'plan-card-20676--selected': selected }"
  >
    <span
      class="plan-card-20676__radio"
      :class="{ 'plan-card-20676__radio--selected': selected }"
    />

    <div class="plan-card-20676__body">
      <div class="plan-card-20676__title-row">
        <span class="plan-card-20676__title">{{ title }}</span>
        <span v-if="savingPercentage" class="plan-card-20676__badge">
          SAVE {{ savingPercentage }}%
        </span>
      </div>
      <p class="plan-card-20676__price">
        {{ plan.price.perMonth }}/mo (billed {{ plan.labels.frequency }} at
        <span class="wg-no-translate">{{ plan.price.perPeriod }}</span
        >)
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { BillingView, PlanView } from '@/models/billing'

const props = defineProps<{
  plan: PlanView
  billing: BillingView
  selected: boolean
}>()

const title = computed(() => `${props.plan.nickname} Plan - 5 Days Free`)

const savingPercentage = computed(() => {
  if (props.plan.id !== 'plan_annual') {
    return null
  }
  return props.billing.switchToAnnualSavings.percent
})
</script>

<style scoped lang="scss">
.plan-card-20676 {
  display: flex;
  align-items: center;
  gap: 12px;
  border-radius: 12px;
  border: 1px solid $c-black-13;
  background: $c-white;
  padding: 14px 16px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: $c-black-6;
  }

  &__radio {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 1.5px solid $c-black-6;
    background: $c-white;

    &--selected {
      border-color: $c-blue-4;
      background: $c-blue-4;
      box-shadow: inset 0 0 0 3px $c-white;
    }
  }

  &__body {
    flex: 1;
    min-width: 0;
  }

  &__title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
    color: $c-black-15;

    @media only screen and (max-width: $w-mobile-s) {
      font-size: 14px;
    }
  }

  &__badge {
    flex-shrink: 0;
    background: $c-red;
    color: $c-white;
    padding: 3px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
    line-height: 16px;
    white-space: nowrap;
  }

  &__price {
    margin-top: 4px;
    font-size: 13px;
    line-height: 18px;
    color: $c-black-6;
  }

  &--selected {
    border-color: $c-blue-4;
    background: #3876f014;
  }
}

.night-mode {
  .plan-card-20676 {
    border-color: $c-dark-5;
    background: rgba(56, 118, 240, 0.08);

    &__title {
      color: $c-white;
    }

    &__radio {
      background: transparent;

      &--selected {
        background: $c-blue-4;
        box-shadow: inset 0 0 0 3px $c-black-15;
      }
    }

    &--selected {
      background: rgba(56, 118, 240, 0.28);
    }
  }
}
</style>
